import { RouteObject } from 'react-router-dom';

import { GlobalLetterSettings } from './GlobalLetterSettings';

export const globalLetterSettingsRoute: RouteObject = {
  path: 'global-letter-settings',
  element: <GlobalLetterSettings />,
};
